module.exports = __webpack_public_path__ + "static/img/beta.20c6c97b.svg";